import { AllPointOfInterestTemplate } from '@/types';

export const checkIfVoi = (
  allVoiTemplates: AllPointOfInterestTemplate,
  poiType: string | undefined
): boolean => {
  if (!poiType) return false;
  return allVoiTemplates.some(
    (voiTemplate) => voiTemplate?.key?.toLowerCase() === poiType.toLowerCase()
  );
};
